/**
 * SafeShare, the staff side (doc 1 section 6.1: Zelma's staff screens live
 * in the Suite's SafeShare tile). Slice 6.1 wakes one tab: Settings, the
 * deliverable presets (admins). The other tabs stay placeholders until
 * their slices.
 *
 * App.jsx hands `activeTab` as an index into the tile's nav (appRegistry.js);
 * a label is accepted too.
 */
import React from "react";
import PresetsAdmin from "./views/PresetsAdmin.jsx";
import { getApp } from "../../lib/appRegistry.js";
import { C, font } from "../../lib/styles.js";

export const tabLabelOf = (activeTab) => {
  const nav = getApp("safeshare")?.navItems ?? [];
  if (typeof activeTab === "number") return nav[activeTab] ?? nav[0];
  return activeTab || nav[0];
};

export default function SafeShareApp({ activeTab, user }) {
  const label = tabLabelOf(activeTab);
  if (label === "Settings") return <PresetsAdmin user={user} />;
  return (
    <div style={{ padding: 60, textAlign: "center", fontFamily: font }}>
      <div style={{ fontSize: 15, color: C.text }}>{label}</div>
      <p style={{ fontSize: 13, color: C.muted }}>Coming with SafeShare. Deliverable presets are in Settings.</p>
    </div>
  );
}
